import { Assets } from "../../assets/Assets";
import { MedicineBoxOutlined } from '@ant-design/icons';
import CalendarArrowUpIcon, {
  AllAppointmentsNavIcon,
  AppointmentRequestsNavIcon,
  BookAppointmentNavIcon,
  ConsolidatedReportNavIcon,
  DailyReportNavIcon,
  DashboardNavIcon,
  DepartmentProfileNavIcon,
  DoctorsNavIcon,
  PatientNavIcon,
} from "../../assets/NavbarIcons/NavIcons";

export const interbranchAdminSideMenu = [
  //  {
  //   options: [
  //    {
  //       name: "Home",
  //       ico: <DashboardNavIcon/>,
  //     },
  //   ],
  // },
  {
    tittle: "Appointments",
    options: [
      {
        name: "All Appointments",
        ico: <AllAppointmentsNavIcon />,
      },
      {
        name: "Book Appointment",
        ico: <BookAppointmentNavIcon />,
        blockedForIDs: ["35460891"] // IDs for which the option is blocked
      },
      {
        name: "Book Request",
        ico: <CalendarArrowUpIcon />,
        blockedForIDs: ["35460891"] // IDs for which the option is blocked
      },
      {
        name: "Appointment Requests",
        ico: <AppointmentRequestsNavIcon />,
      },
    ],
  },
   {
    tittle: "Users",
    options: [
      // {
      //   name: "Doctors",
      //   ico: <DoctorsNavIcon/>,
      // },
      {
        name: "Patients",
        ico: <PatientNavIcon/>,
      },
      // {
      //   name: "Department profiles",
      //   ico: <DepartmentProfileNavIcon/>,
      // },
    ],
  },
  {
    tittle: "MIS REPORTS",
    options: [
      {
        name: "Detailed Report",
        ico: <DailyReportNavIcon />,
      },
      //     // {
      //     //   name: "Consolidate Report",
      //     //   ico: <ConsolidatedReportNavIcon/>,
      //     // },
    ],
  },
  // {
  //   tittle: "Profile",
  //   options: [
  //     {
  //       name: "Doctor",
  //       ico: <DailyReportNavIcon />,
  //     },
  //     //     // {
  //     //     //   name: "Consolidate Report",
  //     //     //   ico: <ConsolidatedReportNavIcon/>,
  //     //     // },
  //   ],
  // },
];



export const SuperAdminSideMenu = [
   {
    options: [
     {
        name: "Home",
        ico: <DashboardNavIcon/>,
      },
    ],
  },
  {
    tittle: "Appointments",
    options: [
      {
        name: "All Appointments",
        ico: <AllAppointmentsNavIcon />,
      },
      {
        name: "Book Appointment",
        ico: <BookAppointmentNavIcon />,
        blockedForIDs: ["35460891","71273898"] // IDs for which the option is blocked
      },
      {
        name: "Appointment Requests",
        ico: <AppointmentRequestsNavIcon />,
      },
    ],
  },
   {
    tittle: "Users",
    options: [
      // {
      //   name: "Doctors",
      //   ico: <DoctorsNavIcon/>,
      // },
      {
        name: "Patients",
        ico: <PatientNavIcon/>,
      },
      // {
      //   name: "Department profiles",
      //   ico: <DepartmentProfileNavIcon/>,
      // },
    ],
  },
  {
    tittle: "Departments",
    options: [
      {
        name: "Manage Departments",
        ico: <DepartmentProfileNavIcon />,
      },
      {
        name: "Manage Specialities",
        ico: <MedicineBoxOutlined />,
      },
    ],
  },
  {
    tittle: "MIS REPORTS",
    options: [
      {
        name: "Detailed Report",
        ico: <DailyReportNavIcon />,
      },
      //     // {
      //     //   name: "Consolidate Report",
      //     //   ico: <ConsolidatedReportNavIcon/>,
      //     // },
    ],
  },
   {
     tittle: "Payment",
    options: [
       {
        name: "Transactions",
       ico: <DailyReportNavIcon />,
       },
  //  {
  //    name: "Consolidate Report",
  //    ico: <ConsolidatedReportNavIcon/>,
  //  },
   ],
  }
];
